import { render, staticRenderFns } from "./announcement-banner.vue?vue&type=template&id=793cd3fe&scoped=true&"
import script from "./announcement-banner.vue?vue&type=script&lang=js&"
export * from "./announcement-banner.vue?vue&type=script&lang=js&"
import style0 from "./announcement-banner.vue?vue&type=style&index=0&id=793cd3fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793cd3fe",
  null
  
)

export default component.exports